<template>
	<div id="usre-baseinfor" class="oh">
		<leftnav class="fl" mkcode="F" itemcode="F-FWSC"></leftnav>
		<div class="index_left servicebook" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="right_topbox" style="min-height: 800px;">
					<div class="servicebookp">
						<div class="pagetitle">
							<h1> {{ curWebsite.type == 9?'深圳市企业并购促进会':'中投顾问' }}产业招商大脑服务手册</h1>
							<p>全国首个saas版云端大数据精准招商、智慧招商平台<span v-if="curWebsite.type == 9">( 由并购促进会与中投顾问公司联合开发)</span></p>
						</div>
						<div class="sima-indctiog" v-if="curWebsite.type == 9">
							<p><b>深圳市企业并购促进会（SIMA）</b>是基于深圳市上市培育工程和企业家培育工程二十年实践基础上而专门设立的产业并购创新行业协会，结盟2800多家政府生产力促进中心网络，全国各地各行业各头部国央企全面覆盖，强大的顾问体系确保与党和国家顶层设计保持紧密同步。</p>
							<p>SIMA是国内首家通过大系统理论和企业服务实践构建的产业端金融创新非营利性组织，形成了以“<b>实控人决策</b>+”服务为抓手，以“我的生产服务”“我的资本路线图”“我的产业上市办”“我的家族经管”“我的并购创新”和“我的城市会客厅”为核心的六大服务板块（1+6服务）。</p>
							<p>秉承一手抓企业发展，一手抓企业家能力建设的做法，致力于从ESG维度为政府（社会）、大企业、小企业<b>（GBSME)</b>各方的共赢与可持续发展提供符合市场逻辑的解决方案，积极探索新时代NGO组织发展新范式 。	</p>
							<p>会员（学员）数量1.6万，A股上市公司成员超400家，专精特新企业成员超5000家，专业顾问1500位，解决方案生态伙伴500余家，伙伴城市数十家。拥有千万级的全国优秀企业大数据。</p>
							<a class="curp" href="https://zs.chanyedanao.cn/dependencyPackage/sima_introduce.pdf" target="_blank">点击查看深圳市企业并购促进会简介 ></a>
						</div>
						<div class="flexdgbg">
							<a href="http://c.ocn.com.cn/special/cydnproduct/indexpx.html" target="_blank" class="adli1 fl">
								<h5>产业招商大脑十大功能 </h5>
								<p>提升工作效率几十倍</p>
							</a>
							<a href="https://share.plvideo.cn/album/index.html?albumId=4841dc66" target="_blank"
								class="adli4 fr">
								<h5>产业招商大脑使用操作说明 </h5>
								<p>用好五个功能模块协助做好招商工作</p>
							</a>
							<a href="http://c.ocn.com.cn/special/dashujukecheng/indexN.html" target="_blank"
								class="adli2 fl">
								<h5>大数据专业招商实战课</h5>
								<p>政府招商圈正在热传的招商培训课程</p>
							</a>
							<a href="https://share.plvideo.cn/album/index.html?albumId=1bac6d3d" target="_blank"
								class="adli3 fr">
								<h5>产业招商大脑视频专辑</h5>
								<p>快速了解产业招商大脑四大功能及其优势</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'servicebook',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			title: '服务手册',
			relationlist: [],
			curWebsite:this.$api.getWebsiteType(),  
		}
	},
	created() {
		this.userdata = this.getuseriformation();
	},
	mounted() {

	},
	methods: {




	}
}  
</script>

<style>
.sima-indctiog{
	background-color: #fff;
	padding: 50px;
	border-radius: 3px;
	box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
	margin-top: 20px;
	line-height: 36px;
	text-indent: 2em;
}
</style>
